module.exports = __webpack_public_path__ + "3d6d284a6861b66c2bb6f7cbab447575.png";